export default "__VITE_ASSET__f0a4c2b3__"